module.exports = __webpack_public_path__ + "static/media/same.812a6dee.svg";